export default "__VITE_ASSET__DfnCq9d___"